export const IconAnalytics: {
  name: 'icon_analytics-c70ebc278c9f'
} = {
  name: 'icon_analytics-c70ebc278c9f'
}
